import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Unit from '../Global/_Unit.js';

gsap.registerPlugin(ScrollTrigger);

export default class EndAnim {
  constructor() {
    // const tl = gsap.timeline({});
    // tl
    //   .fromTo('.end__txt1--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    //   .fromTo('.end__txt2--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    //   .fromTo('.end__txt3--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    //   .fromTo('.end__txt4--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    //   .fromTo('.end__txt5--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    //   .fromTo('.end__txt6--pc', { opacity: 0, y: 30}, { opacity: 1, y: 0, duration: 2, ease: 'power4.out'}, '-=1.5')
    // ;

    // gsap.fromTo(
    //   '.text path',
    //   {
    //     opacity: 0,
    //     y: 10,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     stagger: {
    //       each: 0.05,
    //     },
    //     ease: 'power4.out',
    //   }
    // );

    // this.markerFlg = true;
    const markerFlg = false;

    // this.endTriggerSp;
    // this.endTriggerPc;
    // this.endBtnTrigger;

    // const animHarajukuTxtSp = gsap.fromTo(
    //   '.hebi__containerTxt',
    //   {
    //     opacity: 0,
    //     y: 100,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 1,
    //     ease: 'power4.out',
    //   }
    // );

    // this.animPc = gsap.fromTo(
    //   '.end__txt--pc img',
    //   {
    //     opacity: 0,
    //     y: 35,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 2,
    //     stagger: {
    //       each: 0.5,
    //     },
    //     ease: 'power4.out',
    //   }
    // );

    // this.animSp = gsap.fromTo(
    //   '.end__txt--sp img',
    //   {
    //     opacity: 0,
    //     y: 35,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 2,
    //     stagger: {
    //       each: 0.5,
    //     },
    //     ease: 'power4.out',
    //   }
    // );

    // SP HARAJUKU SUN AD
    ScrollTrigger.create({
      trigger: '.hebi__containerTxt',
      start: 'top 75%',
      // toggleClass: { targets: '.end__container img', className: 'fadeIn' },
      // animation: animHarajukuTxtSp,
      toggleClass: { targets: '.hebi__containerTxt', className: 'fadeIn' },
      toggleActions: 'play none none reverse',
      markers: this.markerFlg,
    });

    ScrollTrigger.create({
      id: 'triggerAnimPc',
      trigger: '.end__txt--pc',
      start: 'top 70%',
      // toggleClass: { targets: '.end__container img', className: 'fadeIn' },
      // animation: this.animPc,
      toggleClass: { targets: '.end__txt--pc', className: 'fadeIn' },
      // animation: tl,
      toggleActions: 'play none none reverse',
      markers: this.markerFlg,
    });

    ScrollTrigger.create({
      id: 'triggerAnimSp',
      trigger: '.end__txt--pc',
      start: 'top center',
      end: $(window).height() + ' top',
      // toggleClass: { targets: '.end__container img', className: 'fadeIn' },
      // animation: this.animSp,
      toggleActions: 'play none none reverse',
      toggleClass: { targets: '.end__txt--sp', className: 'fadeIn' },
      markers: this.markerFlg,
    });

    ScrollTrigger.create({
      trigger: '.end_btn',
      start: Unit.isPc() ? 'top bottom' : 'top 70%',
      // start: 'top bottom',
      toggleClass: { targets: '.end_btn', className: 'fadeIn' },
      markers: this.markerFlg,
    });
  }

  // setScrollTrigger() {
  // }

  // killScrollTrigger() {
  //   // ScrollTrigger.getById('triggerAnimSp').kill();
  //   this.endTriggerPc.kill();
  //   this.endTriggerSp.kill();
  //   gsap.set('.end__txt--pc img', { opacity: 0, y: 35 });
  //   gsap.set('.end__txt--sp img', { opacity: 0, y: 35 });
  // }
}
